import { Box, Dialog, DialogContent, IconButton, Link } from '@mui/material'
import { t } from 'i18next'
import { useSelector } from 'react-redux'

import { CallIcon, CloseIcon, MailIcon } from 'src/components/shared/ui/Icons'
import { userSelector } from 'src/state/authentication/selectors'

import { helpStyles as styles } from './HelpStyles'

type HelpPropsType = {
  open: boolean
  onClose: () => void
}

export default function Help({ open, onClose }: HelpPropsType): JSX.Element | null {
  const user = useSelector(userSelector)

  return (
    <Dialog onClose={onClose} open={open} sx={styles.dialog}>
      <DialogContent>
        <>
          <Box display="flex" flexDirection="row" justifyContent="flex-end">
            <IconButton onClick={onClose} sx={styles.close}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box display="flex" flexDirection="row">
            <Box display="flex" flexDirection="column" flex="1 0 auto" sx={styles.info}>
              <Box className="mainTitle">{t('views.help.contact_us')}</Box>
              <Box
                flex="1 0 auto"
                display="flex"
                flexDirection="column"
                justifyContent="space-evenly"
              >
                <Box display="flex" flexDirection="column" alignItems="center">
                  <MailIcon />
                  <Link href={`mailto:${t('views.help.email')}`} target="_blank">
                    {t('views.help.email')}
                  </Link>
                </Box>
                <Box display="flex" flexDirection="column" alignItems="center">
                  <CallIcon />
                  <Box>
                    <Link
                      href={`tel:${t('views.help.telephone_1').replaceAll(' ', '')}`}
                      target="_blank"
                    >
                      {t('views.help.telephone_1')}
                    </Link>
                    {' - '}
                    <Link
                      href={`tel:${t('views.help.telephone_2').replaceAll(' ', '')}`}
                      target="_blank"
                    >
                      {t('views.help.telephone_2')}
                    </Link>
                  </Box>
                  <Box sx={styles.schedule}>{t('views.help.schedule')}</Box>
                  <Box sx={styles.schedule}>{t('views.help.schedule2')}</Box>
                </Box>
              </Box>
            </Box>
            <Box flex="0 0 263px" sx={styles.help}>
              <Box className="mainTitle">{t('views.help.help_center')}</Box>

              <Link
                sx={styles.actionLink}
                href={`https://centrodeayuda.lefebvre.es/preguntas-frecuentes/?idEntrada=${user?.encryptedLexonId}`}
                target="_blank"
              >
                {t('views.help.questions')}
              </Link>
              <Link
                sx={styles.actionLink}
                href={`https://centrodeayuda.lefebvre.es/videos/?idEntrada=${user?.encryptedLexonId}`}
                target="_blank"
              >
                {t('views.help.videos')}
              </Link>
              <Link
                sx={styles.actionLink}
                href={`https://centrodeayuda.lefebvre.es/manuales/?idEntrada=${user?.encryptedLexonId}`}
                target="_blank"
              >
                {t('views.help.manuals')}
              </Link>
              <Link
                sx={styles.actionLink}
                href={`https://centrodeayuda.lefebvre.es/cursos/?idEntrada=${user?.encryptedLexonId}`}
                target="_blank"
              >
                {t('views.help.courses')}
              </Link>
            </Box>
          </Box>
        </>
      </DialogContent>
    </Dialog>
  )
}
